import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { Advert } from "./advert";
import { useGetAdvertsMutation } from "../api/merchant";

export const ViewAdvertScreen = () => {
  const [getAdverts] = useGetAdvertsMutation();
  const adverts = useSelector((state: RootState) => state.advert.advertList);

  useEffect(() => {
    getAdverts();
  }, []);

  return (
    <div className="grid grid-cols-3 gap-10 m-5">
      {adverts.map((advert) => (
        <Advert advertDetail={advert} key={advert.advertInfoId} />
      ))}
    </div>
  );
};
